const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b46121fd-a518-4f1d-bd1a-ca2489336526",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.28 46.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.6,46.17a.26.26,0,0,1-.3-.3V34a.27.27,0,0,1,.3-.3H2.4a.27.27,0,0,1,.3.3v9.4a.22.22,0,0,0,.2.21h6a.22.22,0,0,0,.2-.21v-8c0-.2.1-.29.3-.29h1.8c.2,0,.3.09.3.29v8a.22.22,0,0,0,.2.21h8.1c.2,0,.3.09.3.29v2a.26.26,0,0,1-.3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,26.67c-.2-.1-.3-.1-.3-.3v-2c0-.2.1-.29.3-.39l19.2-6.81c.2-.1.3,0,.3.2v2c0,.21-.1.3-.3.4l-4.3,1.6v8l4.3,1.5c.2.1.3.21.3.41v2c0,.2-.1.3-.3.2Zm12.5-4.4-9,3.1h0l9,3.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,14.87c-1.1.4-2.3.5-5.6.5s-4.4-.1-5.6-.5c-3.1-1-4.6-3.39-4.6-6.7A6.53,6.53,0,0,1,4.6,1.48C5.7,1.07,6.9,1,10.2,1s4.4.09,5.6.5a4.4,4.4,0,0,1,1.6.69l2-2.1a.33.33,0,0,1,.4,0l1.4,1.3a.3.3,0,0,1,0,.4l-2,2a7.28,7.28,0,0,1,1.2,4.3C20.4,11.48,18.9,13.87,15.8,14.87Zm1.6-9.2-2.2,2.2a.28.28,0,0,1-.4,0l-1.4-1.3a.3.3,0,0,1,0-.4l2.1-2-.4-.1a19,19,0,0,0-4.9-.4,20.31,20.31,0,0,0-4.9.4,4,4,0,0,0-2.9,4.2,4,4,0,0,0,2.9,4.2,19,19,0,0,0,4.9.4,19.66,19.66,0,0,0,4.9-.4A4,4,0,0,0,18,8.27,5,5,0,0,0,17.4,5.67Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq2);
export default __webpack_public_path__ + "static/media/faq_2.2971a2276feb3c9b6290d8d4662017bb.svg";
export { ForwardRef as ReactComponent };